import type { z } from 'zod';

import { NonEmptyText } from './non-empty-text';

export const City = NonEmptyText;

export type City = z.infer<typeof City>;
